/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Campus_Placeholder_TitleInputs */

const en_campus_placeholder_title = /** @type {(inputs: Campus_Placeholder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Campus map · coming soon`)
};

const fr_campus_placeholder_title = /** @type {(inputs: Campus_Placeholder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carte Campus · à venir`)
};

const ms_sg2_campus_placeholder_title = /** @type {(inputs: Campus_Placeholder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peta Kampus · akan datang`)
};

/**
* | output |
* | --- |
* | "Campus map · coming soon" |
*
* @param {Campus_Placeholder_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const campus_placeholder_title = /** @type {((inputs?: Campus_Placeholder_TitleInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Campus_Placeholder_TitleInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_campus_placeholder_title(inputs)
	if (locale === "fr") return fr_campus_placeholder_title(inputs)
	return ms_sg2_campus_placeholder_title(inputs)
});